import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as constants from '../../backend/constants';
import TagInput from '../tag-input/TagInput.jsx';

import s from './BulkChangeConfigurator.module.scss';

export default class BulkTagEditor extends Component {
    static propTypes = {
        fieldConfig: PropTypes.object,
        value: PropTypes.array,
        onChange: PropTypes.func,
        changeType: PropTypes.string,
    };

    getHelpText = () => {
        const { fieldConfig, changeType } = this.props;
        switch (changeType) {
            case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.ARRAY_ADD:
                return `The following will be added to the existing ${fieldConfig.pluralTitle}`;
            case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.ARRAY_REMOVE:
                return `The following will be removed from the existing ${fieldConfig.pluralTitle}`;
            case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE:
                return `Replace all the ${fieldConfig.pluralTitle} with the following...`;
            default:
                return '';
        }
    };

    getWarningText = () => {
        const { fieldConfig, changeType } = this.props;
        switch (changeType) {
            case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.ARRAY_ADD:
                return fieldConfig.field === 'displayTags' ? 'Note: Any tags added above the existing 10 tag limit for each of the selected POIs will be ignored.' : '';
            case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE:
                return `Note: This will delete ALL ${fieldConfig.pluralTitle} for the selected POIs`;
            default:
                return '';
        }
    };

    render() {
        const { value, onChange, changeType, fieldConfig } = this.props;
        if (!changeType) {
            return null;
        }

        const helpText = this.getHelpText();
        const warningText = this.getWarningText();
        const tagLimit = fieldConfig.field === 'displayTags' ? 10 : Number.MAX_SAFE_INTEGER; // Either maximum of 10 tags or 'unlimited' hidden tags
        const showTagInput = changeType !== constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE;

        return (
            <div>
                <div className={s.dividerWithText}>{helpText}</div>
                {warningText && (
                    <div className={s.warningText}>
                        <div className={classNames('icon-warning', s.warningIcon)} />
                        {warningText}
                    </div>
                )}
                {showTagInput && <TagInput tags={value} onChange={onChange} maxItems={tagLimit} />}
            </div>
        );
    }
}
